<script lang="ts">
  import { onMount } from "svelte";
  import DateNavHeader from "./DateNavHeader.svelte";
  import { workouts, loadWorkouts } from "../lib/workoutsStore";
  import { selectedWorkoutUUID } from "../lib/state";
  import { openOverlay } from "../lib/overlay";
  import { formatWorkoutDay, formatWorkoutDayShort } from "../lib/format";
  import { swimNavState } from "../lib/swimNav";
  import { haptic } from "../lib/haptics";

  // Boot the shared workout list (this header is the always-mounted Swim-tab
  // reader of `workouts` — date, prev/next nav, the calendar sheet).
  onMount(() => { void loadWorkouts(); });

  let currentSwim = $derived(
    $selectedWorkoutUUID === null
      ? ($workouts[0] ?? null)
      : ($workouts.find((w) => w.uuid === $selectedWorkoutUUID) ?? $workouts[0] ?? null),
  );
  let dateText = $derived(currentSwim ? formatWorkoutDay(currentSwim.startDate) : "Your swims");
  let nav = $derived(swimNavState($workouts, $selectedWorkoutUUID));

  function openCalendar() {
    openOverlay({ kind: "your-swims" });
  }
  function goPrev() {
    if (!nav.canPrev) return;
    haptic("selection");
    selectedWorkoutUUID.set(nav.prev);
  }
  function goNext() {
    if (!nav.canNext) return;
    haptic("selection");
    selectedWorkoutUUID.set(nav.next);
  }
</script>

<DateNavHeader
  {dateText}
  shortDateText={currentSwim ? formatWorkoutDayShort(currentSwim.startDate) : null}
  canPrev={nav.canPrev}
  canNext={nav.canNext}
  onPrev={goPrev}
  onNext={goNext}
  prevLabel="Previous swim, older"
  nextLabel="Next swim, newer"
  onOpenCalendar={openCalendar}
  calendarLabel="Open your swims calendar"
/>
